import React from "react";
import { CardOfTheDayDomain } from "@/types/Card";
import { UI_STYLES } from "@/styles/uiStyles";

interface CardOfTheDayViewProps {
  card: CardOfTheDayDomain;
  timeToNextCard: string;
}

const CardOfTheDayView: React.FC<CardOfTheDayViewProps> = ({
  card,
  timeToNextCard,
}) => (
  <>
    <div className="flex flex-col items-center w-full h-full overflow-y-hidden">
      <div className="flex flex-col items-center w-full ">
        <div className="flex flex-col items-center mt-2 mb-2 w-full max-w-xl mx-auto px-2">
          <div
            className={`w-full max-w-xs  ${UI_STYLES.bgDarkBlue4} rounded-full flex flex-col items-center justify-center text-xs text-white/70 font-medium`}
          >
              <div className="text-white text-xs">
                Открытие через
              </div>
              <div className="text-white text-xs">
                {timeToNextCard}
              </div>
          </div>
        </div>
        <div className="flex items-center justify-start px-2 sm:px-4 mb-2 w-full max-w-xl mx-auto">
          <div
            className={`${UI_STYLES.bgDarkBlue4} text-white text-sm  rounded-full px-6 py-1`}
          >
            {card.name}
          </div>
        </div>
        <div className="relative w-full flex flex-col items-center">
          <img
            src={card.image ?? ""}
            alt={card.name}
            className={`object-cover rounded-xl shadow-lg border-4 ${UI_STYLES.bgDarkBlue4} bg-white mt-2 mb-4 h-64`}
          />

          <div className="text-white text-lg  mb-2 text-center">
            {card.name}
          </div>
          <div
            className={`w-full sm:p-3 absolute left-0 top-0 min-h-[800px] h-full overflow-y-auto hide-scrollbar`}
            style={{
              marginBottom: 24,
              boxSizing: "border-box",
              paddingTop: 80,
            }}
          >
            <div className="h-[250px]"></div>
            <div
              className={`text-white text-sm text-justify leading-relaxed rounded-2xl p-4 ${UI_STYLES.bgDarkBlue4} `}
            >
              {card.description}
            </div>
            <div className="h-[450px]"></div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default CardOfTheDayView;
